/**
 * Format USD value.
 * @param {number|string} value
 * @returns
 */
export const formatCurrency = (value) => {
    return parseFloat(value).toFixed(2);
};

/**
 * Format millix in human readable form.
 * @param {number} number
 * @returns
 */
export const renderFormatCurrency = (number) => {
    return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

/**
 *  Format millix value.
 * @param {number|string} value
 * @returns
 */
export const formatMillix = (value) => {
    return Math.floor(value);
};

/**
 * Format millix in human readable form.
 * @param {number} number
 * @returns
 */
export const renderFormatMillix = (number) => {
    return Math.floor(number).toLocaleString("en-US");
};

/**
 * Thousand separate value.
 * @param {number|string} value Value
 * @param {string} delimiter Separator. Default - `Comma (,)`
 * @returns
 */
export const thousandSeparate = (value, delimiter = ',') => {
    return value
        .toString()
        .replace(/[^0-9]/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
};

export const DEFAULT_PROFILE_PICTURE_URL = '/images/pagado_icon_xs.png';

export const resolveServerAssetUrl = (assetPath) => {
    if (!assetPath || /^(https?:)?\/\//i.test(assetPath)) {
        return assetPath;
    }

    const browserOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : '';
    const serverOrigin = process.env.REACT_APP_SERVER || browserOrigin;

    if (!serverOrigin) {
        return assetPath;
    }

    try {
        return new URL(assetPath, serverOrigin).toString();
    } catch (_error) {
        return assetPath;
    }
};

export const getProfilePictureSrc = (profilePictureUrl) => {
    if (!profilePictureUrl) {
        return DEFAULT_PROFILE_PICTURE_URL;
    }

    return resolveServerAssetUrl(profilePictureUrl);
};
